module.exports = __webpack_public_path__ + "img/4_AR-mb.1f466da3.png";